import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER, ErrorHandler, Injector } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { GlobalVariable } from './app.config';
import { KxSharedModule } from 'src/modules/kx-shared/kx-shared.module';
import { ErrorModule } from 'src/modules/base/error/error.module';
import { TranslateModule } from 'src/modules/base/pipes/translate.module';
import { MessagingService } from 'src/modules/base/shared/services/messaging.service';
import { GlobalErrorHandler } from 'src/modules/base/services/error-handling.service';
import { ErrorService } from 'src/modules/base/services/error.service';
import { TelemedicineModule } from 'src/modules/telemedicine/telemedicine.module';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/modules/base/guards/auth.gaurd';
import { NgxSpinnerModule } from 'src/modules/base/components/ngx-spinner/ngx-spinner.module';
import { HttpClient, HttpHeaders, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DEFAULT_TIMEOUT, TimeoutInterceptor } from 'src/modules/base/shared/services/base.service';
import { ErrorLoggingService } from 'src/modules/base/services/error-logging.service';
import { TranslateService } from 'src/modules/base/services/translate.service';
import { ChatBotModule } from 'src/modules/chatbot/chatbot.module';
import { environment } from 'src/environments/environment.prod';
import { ServiceWorkerModule } from '@angular/service-worker';

declare var NProgress: any;
declare var getUserTimezone: any
export function initConfiguration(appService: AppService, http: HttpClient, router: Router, injector: Injector) {
  return () => {
    
    appService.init(GlobalVariable);
    
    if (window.navigator.onLine) {
      NProgress.inc();
      NProgress.inc(0.4);

      /*************** USED TO GET APPLICATION AND PERMISSIONS (DEFINED IN BASE SERVICE ALSO) ****/
      if (appService.getSessionId() && appService._appData.APPLICATION_AWARE) {
        var currentuser = appService.getCurrentUser();
        if(currentuser != undefined){
          var super_app_url = currentuser.super_app_url;
          console.log ("super_app_url --> ", super_app_url);
          console.log ("app_module --> ", window.location.origin);
          if(super_app_url != undefined && super_app_url =="/crm/"){
            console.log ("super_app_url is not root url");
            window.location.href= window.location.origin + super_app_url;
          } else {
            return getMyConfig(0,appService,http,router,injector);
          }
        }
      } else {
        return getAccontConfiguration(appService, http,router);
      }
    } else {
      /************* APP IS OFFLINE ****************/
      router.navigate(['offline']);
      /************* APP IS OFFLINE ****************/
    }


  }
  /*************** USED TO GET APPLICATION AND PERMISSIONS (DEFINED IN BASE SERVICE ALSO) ****/
}


function getMyConfig(tryCount,appService,http,router,injector){
  tryCount = tryCount+1;
  if(tryCount>3){
    var msg = "Network timeout, Please refresh.";
    alert(msg);
    return new Promise<boolean>((resolve, reject) => {
      NProgress.done();
      document.getElementsByTagName('app-root')[0].innerHTML = msg;
      resolve(true);
    });
  }else{
    // var lazyservice:LazyService = injector.get(LazyService);
    appService._applications = [];
    let args = "dummy:dummy";
    let queryId = "GET_MY_CONFIG";
    let resource = "application_master";
    if (window.location.hostname.substring(0, window.location.hostname.indexOf('.')) != 'karexpert' && window.location.hostname != 'localhost'  && window.location.hostname.indexOf('admin.dvc.')== -1 ) {
      
      args += ",host_url:" + window.location.hostname;
      var account_url = appService.getAccountUrl();
      args += ",account_url:" + account_url;
    }
    var url = appService.getApiEndpoint('api', appService._appData.DEFAULT_APPLICATION) + resource + '?queryId=' + queryId + '&args=' + args + "&application=" + appService._appData.DEFAULT_APPLICATION;
    var urlData = url.split("?");
    var options: any = {};
    if (urlData[1] != undefined) {
      options.headers = appService.addXsrfToken(urlData[1],true).headers;
    } else {
      options.headers = appService.addXsrfToken("",true).headers;
    }
    var menuParser: any = false;
    try {
      if (appService._appData.DECORATOR_DEF['menuParseDecorator'] != undefined) {
        menuParser = new appService._appData.DECORATOR_DEF['menuParseDecorator']();
      }
    } catch (e) {
      console.warn(e)
    }
    return new Promise<boolean>((resolve, reject) => {
      http.get(url, options).subscribe((resp: any) => {

        if (resp.errCode == 0 && resp.resource != undefined && resp.resource.length) {

          appService.setSuperApps(resp.resource[0].super_apps);
          /************** MENU DECORATOR ***********/
          if (resp.resource[0].menus != undefined && menuParser) {
            resp.resource[0].menus = menuParser.parseMenu(resp.resource[0], appService, injector);
          }
          /************** MENU DECORATOR ***********/
          if (resp.resource[0].landing_url_array != undefined && resp.resource[0].landing_url_array.length > 0) {
            var deviceType = /iPhone|iPad|iPod|Android|webOS|BlackBerry|Windows Phone/i.test(navigator.userAgent);
            resp.resource[0].landing_url_array.forEach(element => {
              if (!deviceType && element.device_type_id == "web") {
                resp.resource[0].landing_url = element.landing_url
                return
              }
              else if (deviceType && element.device_type_id == "mobile") {
                resp.resource[0].landing_url = element.landing_url
                return
              }
              else if (element.device_type_id == "all") {
                resp.resource[0].landing_url = element.landing_url
              }
            });
          }
          appService.parseMyConfigObject(resp.resource[0]);
          //appService.addWCAGEnabled(resp.resource[0]);
          // if (!appService.getCurrentLocation() && !localStorage.getItem("deletedLocation")) { appService.setCurrentLocation(resp.resource[0].location.find(x => x.is_default == true)); }

          /******** ADDING DYNAMIC MODULES  ********/
          if (resp.resource[0].dynamic_application != undefined && resp.resource[0].dynamic_application.length) {
            var paths = router.config;
            appService.buildDynamicApp(router, paths, resp.resource[0].dynamic_application, AuthGuard);
          }
          /******** ADDING DYNAMIC MODULES  ********/

          /******** ADDING NOCODE MODULES  ********/
          if (resp.resource[0].nocode_application != undefined && resp.resource[0].nocode_application.length) {
            var paths = router.config;
            appService.buildNocodeApp(router, paths, resp.resource[0].nocode_application, AuthGuard);
          }
          /******** ADDING NOCODE MODULES  ********/

          /** EULA *
          var url = appService.getApiEndpoint('api', "dms") + "eula_document" + '?queryId=' + "GET_EULA_LINKS";
          var urlData = url.split("?");
          var  options:any = {};
          if(urlData[1] != undefined){
            options.headers = appService.addXsrfToken(urlData[1]).headers;
          }else{
            options.headers = appService.addXsrfToken("").headers;
          }
          http.get(url,options).subscribe(
            (data: any) => {
              if (data.erroCode != -1) {
                appService.parseEula(data['resource']);
              }
            });
          /** EULA */
          resolve(true);
        } else {
          //LogoutUser
          appService.logout(() => {
            localStorage.clear();
            getAccontConfiguration(appService, http, router,resolve);
          })

        }

        NProgress.done();
      }, (error) => {
        console.log(error);
        getMyConfig(tryCount,appService,http,router,injector);
      });
    });
  }
}
function getAccontConfiguration(appService, http, router: Router, resolve: any = false) {
  appService._applications = [];
  var account_url = window.location.hostname;
 // var account_url = "artemis.ehr.kxaction.com";
  let args = "account_url:" + account_url;
  let queryId = "GET_ACCOUNT_CONFIGURATION";
  let resource = "get_account_config";
  let url = appService.getApiEndpoint('api', appService._appData.DEFAULT_APPLICATION) + resource + '?queryId=' + queryId + '&args=' + args + "&application=" + appService._appData.DEFAULT_APPLICATION
  var headers = new HttpHeaders()
    .set('timezone', getUserTimezone())
    .set('current_time', appService.getCurrentTime())
    .set('X-XSRF-TOKEN',appService.getXsrfToken(url.split("?")[1],false))
  return http.get(url, { headers })
    .toPromise()
    .then((resp: any) => {
      if (resp.errCode == 0 && resp.resource != undefined && resp.resource.length) {
        if (appService._currentSessionData == undefined) {
          appService._currentSessionData = {};
        }

        if (resp.resource[0].header == undefined) {
          resp.resource[0].header = {};
        }
        if (resp.resource[0].main_account != undefined) {
          resp.resource[0].header.main_account = resp.resource[0].main_account;
        }
        if (resp.resource[0].account_id != undefined) {
          resp.resource[0].header.account_id = resp.resource[0].account_id;
        }

        appService.setAppHeader(resp.resource[0].header);
        appService.setLanguageList(resp.resource[0].language);
        appService.setAppPackage(resp.resource[0].app_package != undefined ? resp.resource[0].app_package : "");
        appService.setExcludedRolesPoweredBy(resp.resource[0]);
        appService.setSuperApps(resp.resource[0].super_apps);
        appService.setStreamSaver(resp.resource[0].streamsaver);

      if(resp.resource[0].authentication_type != undefined && (resp.resource[0].authentication_type == "Active Directory" || resp.resource[0].authentication_type == "sso_login")){
          appService.setAdConfig(resp.resource[0].ad_config);
        }else{
          appService.removeAdConfig()
        }
        if(resp.resource[0].default_app != undefined && resp.resource[0].default_app){
          appService.setDefaultApp(resp.resource[0].default_app);
        }
      }
      NProgress.done();
      if (resolve) {
        resolve(true);
      }
    }).catch(() => {
      NProgress.done();
      if (resolve) {
        resolve(true);
      }
    });
}



@NgModule({ declarations: [
        AppComponent
    ],
    exports: [
        NgxSpinnerModule,
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        NgxSpinnerModule,
        KxSharedModule,
        ErrorModule,
        TranslateModule,
        ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production,registrationStrategy: 'registerImmediately'}),
        //ServiceWorkerModule.register('custom-service-worker-12.0.3.js', { enabled: environment.production, registrationStrategy: 'registerImmediately' }),
        TelemedicineModule,
        ChatBotModule], providers: [
        TranslateService,
        {
            provide: APP_INITIALIZER,
            useFactory: initConfiguration,
            multi: true,
            deps: [AppService, HttpClient, Router, Injector]
        },
        [{ provide: HTTP_INTERCEPTORS, useClass: TimeoutInterceptor, multi: true }],
        [{ provide: DEFAULT_TIMEOUT, useValue: 60000 }],
        { provide: APP_INITIALIZER, useFactory: translateService, deps: [TranslateService], multi: true },
        MessagingService,
        ErrorService, ErrorLoggingService,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }

export function translateService(translateService: TranslateService) {
  let local_language = localStorage.getItem("appLanguage");
  if (local_language == undefined || local_language == "")
    local_language = "en"
  //"en"  
  return () => translateService.setLanguage(local_language, () => {

  });
}
